export enum OAuthErrors {
    INVALID_GRANT = 'invalid_grant',
    INVALID_TOKEN = 'invalid_token',
    UNAUTHORIZED = 'Unauthorized'
}